import createUseContext from 'constate';
import { useReducer } from 'react';
import { createReducer } from 'helpers/reducers-helper';
import merge from 'lodash/merge';
import moment from 'moment';

export const FILTER_ORDER = 'FILTER_ORDER';

const useOrders = () => {
  const initState = {
    filterOption: {
      startAt: moment()
        .subtract(1, 'month')
        .add(1, 'day')
        .startOf('day')
        .toDate(),
      endAt: moment()
        .endOf('day')
        .toDate(),
      transactionTypes: [],
    },
  };

  const filterOrder = (state, { plateNumber, startAt, endAt, transactionTypes }) => {
    return merge({}, initState, {
      filterOption: {
        plateNumber,
        transactionTypes,
        startAt,
        endAt,
      },
    });
  };

  const reducer = createReducer({ [FILTER_ORDER]: filterOrder }, initState);

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch };
};

export const useOrdersContext = createUseContext(useOrders);
